import { LocalizedValueModel } from '../../localized-value.model';

export class TimeZonePresenterModel {
  daylight_saving_time_dst?: boolean;
  id?: string;
  time_difference: string;
  time_zone: LocalizedValueModel;
  time_zone_id: string;
}
